<template>
    <b-row> 
        <b-card-group class="col-md-6 col-sm-12 " v-for="(item, index) of items" :key="index" >
            <b-card class="shadow-lg my-3">
                <b-row no-gutters>
                    <b-col cols="4">
                        <b-card-img :src="item.imagen" alt="Image" class="mb-5" style="cursor: pointer" @click.prevent="$emit('item-info', item)"></b-card-img>
                    </b-col>
                    <b-col cols="8">
                        <b-card-text>
                            <a class="brown--text" @click.prevent="itemInfo(item)">{{item.nombre}}</a> <br>
                            Item: {{item.codigo}} <br>
                            Precio: <span class="text-warning price-size"> ${{numberFormat(item.precio)}} </span>
                            <div v-if="opcionExistencia === 1">Cantidad Disponible: {{numberFormat(item.existencia)}} </div>
                            <div>Código de Barras: <strong> {{item.codigo_barras}} </strong> </div>
                            <div class="producto-agotado" v-if="item.existencia === 0 && opcionExistencia === 1"><strong>Producto Agotado</strong></div>
                        </b-card-text>
                    </b-col>
                </b-row>
                <template #footer>
                    <Footer :item="item" />
                </template>
            </b-card>
        </b-card-group>
    </b-row>
</template>

<script>
import { mapState} from 'vuex'
import Footer from './Footer.vue'
export default {
    name: "CardItem2",
    props: {
        items: {
            type: Array
        }       
    },
    computed: {
        ...mapState('configuration', ['opcionExistencia']),
        ...mapState('auth', ['user']),
    },
    components: {
        Footer
    },
};

</script>
<style scoped>
.card-img { 
    max-width: 100%; 
    max-height: 150px;
    object-fit: scale-down;
}

.card-text {
    font-size: 14px;
}

.producto-agotado{
    font-size: 18px;
    color: red;
}

.price-size{
    font-size: 18px;
}


</style>